<template>
  <div class="sidebar">
    <ul>
      <li></li>
      <router-link to="/nsb-baru" class="link">
        <li
          @click="current = '/nsb-baru'"
          :class="{ active: current == '/nsb-baru' }"
          @mouseover="iconNsbBar = require('@/assets/iconImage/nasabah_baru_active.png')"
          @mouseleave="iconNsbBar = require('@/assets/iconImage/nasabah_baru_inactive.png')"
        >
          <img :src="current == '/nsb-baru' ? require('@/assets/iconImage/nasabah_baru_active.png') : iconNsbBar" class="img-sidbar" />
          Nasabah Baru
        </li>
      </router-link>
      <router-link to="/nsb-terdaftar" class="link">
        <li
          @click="current = '/nsb-terdaftar'"
          :class="{ active: current == '/nsb-terdaftar' }"
          @mouseover="iconNsbTer = require('@/assets/iconImage/nasabah_terdaftar_active.png')"
          @mouseleave="iconNsbTer = require('@/assets/iconImage/nasabah_terdaftar_inactive.png')"
        >
          <img :src="current == '/nsb-terdaftar' ? require('@/assets/iconImage/nasabah_terdaftar_active.png') : iconNsbTer" class="img-sidbar" />
          Nasabah Terdaftar
        </li>
      </router-link>

      <li
        @click="logout"
        @mouseover="iconLogout = require('@/assets/iconImage/logout_active.png')"
        @mouseleave="iconLogout = require('@/assets/iconImage/logout_inactive.png')"
      >
        <img :src="iconLogout" class="img-sidbar" /> Logout
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "",
      hover: false,
      dasboard: require("@/assets/iconImage/dashboard_active.png"),
      imgDashboard: require("@/assets/iconImage/Asset79.png"),
      iconLogout: require("@/assets/iconImage/logout_inactive.png"),
      iconNsbTer: require("@/assets/iconImage/nasabah_terdaftar_inactive.png"),
      iconNsbBar: require("@/assets/iconImage/nasabah_baru_inactive.png"),
      iconNsbRjk: require("@/assets/iconImage/nasabah_reject_inactive.png"),
      iconNsbBlk: require("@/assets/iconImage/nasabah_blacklist_inactive.png"),
    };
  },
  methods: {
    toggle(e) {
      var elems = document.getElementsByClassName("sub-menu");
      if (elems[e].classList.value === "sub-menu") {
        elems[e].classList.add("active-menu");
      } else {
        elems[e].classList = "sub-menu";
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.go("/home");
      });
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 219px;
}

ul {
  padding: 0;
}

ul li {
  list-style: none;
  line-height: 2.5;
}

li {
  /* height: 60px; */
  align-items: center;
  font-size: 14px;
  padding: 12px 25px;
  cursor: pointer;
  color: #707070;
}

li:hover {
  /* background-color: rgba(230, 230, 230, 0.25);  */
  color: #6454f0;
  /* position: relative; */
}

.sub-menu {
  padding: 0 0 0 15px;
  display: none;
  transition: ease-out 0.5s;
}

a .router-link-active li {
  background-color: rgba(230, 230, 230, 0.25);
  color: #6454f0;
}

.active-menu {
  display: block;
}

.active {
  background-color: rgba(230, 230, 230, 0.25);
  color: #6454f0;
  position: relative;
}
.active::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 100%;
  background: #6454f0;
  left: 0;
  top: 0px;
}

.link:hover {
  text-decoration: none;
}

.icon-sidebar {
  font-size: 20px;
  margin-right: 10px;
}
.img-sidbar {
  width: 18px;
  margin-right: 10px;
  vertical-align: text-top;
}

.menu-eksternal {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
